import type {
  ChecklistItemEntity,
  TagEntity,
  TaskEntity,
} from '../../../entities/task/model/task.types';
import type { TaskPriority } from '../../../shared/lib/datetime';
import type { RecurrenceRule } from '../model/recurrence';
import { parseRecurrenceRule } from '../model/recurrence';

export interface ChecklistDraftItem {
  id: string;
  text: string;
  done: boolean;
  sortOrder: number;
  isNew: boolean;
}

export interface TaskDraft {
  title: string;
  description: string;
  priority: TaskPriority;
  dueDate: string | null;
  dueTime: string | null;
  durationMinutes: number | null;
  allDay: boolean;
  /** Правило повторения в JSON-строке или null. */
  recurrenceRule: string | null;
  recurrence: RecurrenceRule | null;
  recurrenceEnabled: boolean;
  tagIds: string[];
  /** Проект задачи. null — «Без проекта». */
  projectId: string | null;
  checklist: ChecklistDraftItem[];
}

export function emptyTaskDraft(): TaskDraft {
  return {
    title: '',
    description: '',
    priority: 'medium',
    dueDate: null,
    dueTime: null,
    durationMinutes: null,
    allDay: false,
    recurrenceRule: null,
    recurrence: null,
    recurrenceEnabled: false,
    tagIds: [],
    projectId: null,
    checklist: [],
  };
}

export function taskToDraft(
  task: TaskEntity,
  tagIds: string[],
  checklist: ChecklistItemEntity[],
): TaskDraft {
  const rule = parseRecurrenceRule(task.recurrence_rule);
  return {
    title: task.title,
    description: task.description,
    priority: task.priority,
    dueDate: task.due_date,
    dueTime: task.due_time,
    durationMinutes: task.duration_minutes,
    allDay: task.all_day,
    recurrenceRule: task.recurrence_rule,
    recurrence: rule,
    recurrenceEnabled: rule !== null,
    tagIds: [...tagIds],
    projectId: task.project_id,
    checklist: checklist
      .slice()
      .sort((a, b) => a.sort_order - b.sort_order || a.id.localeCompare(b.id))
      .map((item) => ({
        id: item.id,
        text: item.text,
        done: item.done,
        sortOrder: item.sort_order,
        isNew: false,
      })),
  };
}

export function tagIdsFromLinks(taskId: string, links: { task_id: string; tag_id: string; deleted_at: string | null }[]): string[] {
  return links
    .filter((link) => link.task_id === taskId && link.deleted_at === null)
    .map((link) => link.tag_id);
}

export function sortTagOptions(tags: TagEntity[]): TagEntity[] {
  return [...tags].sort((a, b) => a.name.localeCompare(b.name, 'ru'));
}
